import React from 'react';
import { useNavigate } from 'react-router-dom';

const PoliticaPrivacidade: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-500 via-purple-500 to-purple-600">
      <div className="max-w-4xl mx-auto px-4 py-8">
        {/* Header com botão voltar */}
        <div className="mb-6">
          <button
            onClick={() => navigate(-1)}
            className="mb-4 text-white hover:text-white/80 flex items-center gap-2 px-4 py-2 hover:bg-white/10 rounded-lg transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
            </svg>
            Voltar
          </button>
        </div>

        {/* Card principal */}
        <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-12">
          {/* Header */}
          <div className="text-center pb-8 border-b-4 border-green-600 mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-green-700 mb-3">Política de Privacidade</h1>
            <p className="text-gray-600 text-lg">Rota Entregas</p>
          </div>

          {/* Conteúdo */}
          <div className="prose prose-lg max-w-none">
            {/* Seção 1 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                1. Informações Coletadas
              </h2>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">Dados Pessoais</h3>
              <ul className="list-disc pl-8 mb-6 space-y-2 text-gray-900">
                <li className="text-gray-900">Nome completo</li>
                <li className="text-gray-900">CPF/CNPJ</li>
                <li className="text-gray-900">Endereço</li>
                <li className="text-gray-900">Telefone</li>
                <li className="text-gray-900">E-mail</li>
                <li className="text-gray-900">Foto do perfil</li>
                <li className="text-gray-900">Documentos (CNH, fotos da moto)</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">Dados de Localização</h3>
              <ul className="list-disc pl-8 mb-6 space-y-2 text-gray-900">
                <li className="text-gray-900">Localização GPS em tempo real</li>
                <li className="text-gray-900">Histórico de rotas</li>
                <li className="text-gray-900">Endereços de entrega</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">Dados de Uso</h3>
              <ul className="list-disc pl-8 mb-6 space-y-2 text-gray-900">
                <li className="text-gray-900">Histórico de entregas</li>
                <li className="text-gray-900">Avaliações e feedback</li>
                <li className="text-gray-900">Dados de pagamento</li>
              </ul>

              <h3 className="text-xl font-semibold text-gray-900 mb-3 mt-6">Dados de Mídia</h3>
              <ul className="list-disc pl-8 mb-6 space-y-2 text-gray-900">
                <li className="text-gray-900">Fotos tiradas através da câmera do dispositivo</li>
                <li className="text-gray-900">Imagens de documentos para verificação</li>
                <li className="text-gray-900">Fotos de perfil do usuário</li>
              </ul>
            </section>

            {/* Seção 2 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                2. Permissões do Dispositivo
              </h2>

              <p className="mb-6 text-gray-900">Nosso aplicativo solicita as seguintes permissões para funcionamento adequado:</p>

              <div className="bg-gray-50 p-6 rounded-lg mb-6 border-l-4 border-green-500">
                <div className="font-bold text-green-700 mb-4">Câmera (android.permission.CAMERA)</div>
                <ul className="list-disc pl-6 space-y-2 text-gray-900">
                  <li className="text-gray-900"><strong className="text-gray-900">Finalidade:</strong> Captura de fotos para perfil do usuário, documentos de identificação e comprovantes de entrega</li>
                  <li className="text-gray-900"><strong className="text-gray-900">Uso:</strong>
                    <ul className="list-disc pl-6 mt-2 space-y-1 text-gray-900">
                      <li className="text-gray-900">Foto de perfil do entregador</li>
                      <li className="text-gray-900">Documentos de identificação (CNH, RG)</li>
                      <li className="text-gray-900">Fotos da moto para verificação</li>
                      <li className="text-gray-900">Comprovantes de entrega</li>
                    </ul>
                  </li>
                  <li className="text-gray-900"><strong className="text-gray-900">Armazenamento:</strong> As imagens são armazenadas de forma segura em nossos servidores</li>
                  <li className="text-gray-900"><strong className="text-gray-900">Compartilhamento:</strong> Apenas com empresas contratantes quando necessário para verificação</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg mb-6 border-l-4 border-green-500">
                <div className="font-bold text-green-700 mb-4">Localização (android.permission.ACCESS_FINE_LOCATION, android.permission.ACCESS_COARSE_LOCATION)</div>
                <ul className="list-disc pl-6 space-y-2 text-gray-900">
                  <li className="text-gray-900"><strong className="text-gray-900">Finalidade:</strong> Rastreamento em tempo real para otimização de rotas</li>
                  <li className="text-gray-900"><strong className="text-gray-900">Uso:</strong> Localização do entregador durante entregas ativas</li>
                  <li className="text-gray-900"><strong className="text-gray-900">Armazenamento:</strong> Dados de localização são mantidos apenas durante entregas ativas</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg mb-6 border-l-4 border-green-500">
                <div className="font-bold text-green-700 mb-4">Áudio (android.permission.RECORD_AUDIO, android.permission.MODIFY_AUDIO_SETTINGS)</div>
                <ul className="list-disc pl-6 space-y-2 text-gray-900">
                  <li className="text-gray-900"><strong className="text-gray-900">Finalidade:</strong> Funcionalidade de chat por voz e notificações</li>
                  <li className="text-gray-900"><strong className="text-gray-900">Uso:</strong> Comunicação entre entregadores e empresas</li>
                  <li className="text-gray-900"><strong className="text-gray-900">Armazenamento:</strong> Mensagens de áudio são temporárias</li>
                </ul>
              </div>
            </section>

            {/* Seção 3 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                3. Como Usamos Suas Informações
              </h2>
              <ul className="list-disc pl-8 space-y-2 text-gray-900">
                <li className="text-gray-900"><strong className="text-gray-900">Funcionamento do App:</strong> Para gerenciar entregas e conectar entregadores com empresas</li>
                <li className="text-gray-900"><strong className="text-gray-900">Localização:</strong> Para rastreamento em tempo real e otimização de rotas</li>
                <li className="text-gray-900"><strong className="text-gray-900">Câmera:</strong> Para verificação de identidade e documentação</li>
                <li className="text-gray-900"><strong className="text-gray-900">Pagamentos:</strong> Para processar pagamentos e transferências</li>
                <li className="text-gray-900"><strong className="text-gray-900">Comunicação:</strong> Para notificações e chat entre usuários</li>
                <li className="text-gray-900"><strong className="text-gray-900">Melhorias:</strong> Para melhorar nossos serviços</li>
              </ul>
            </section>

            {/* Seção 4 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                4. Compartilhamento de Dados
              </h2>
              <ul className="list-disc pl-8 space-y-2 text-gray-900">
                <li className="text-gray-900"><strong className="text-gray-900">Empresas:</strong> Dados necessários para contratar entregadores (incluindo fotos de documentos quando necessário)</li>
                <li className="text-gray-900"><strong className="text-gray-900">Entregadores:</strong> Informações de entrega e localização</li>
                <li className="text-gray-900"><strong className="text-gray-900">Prestadores de Serviço:</strong> Processamento de pagamentos</li>
                <li className="text-gray-900"><strong className="text-gray-900">Autoridades:</strong> Quando exigido por lei</li>
              </ul>
            </section>

            {/* Seção 5 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                5. Segurança
              </h2>
              <ul className="list-disc pl-8 space-y-2 text-gray-900">
                <li className="text-gray-900">Criptografia de dados</li>
                <li className="text-gray-900">Acesso restrito</li>
                <li className="text-gray-900">Backup seguro</li>
                <li className="text-gray-900">Monitoramento contínuo</li>
                <li className="text-gray-900">Proteção especial para imagens e documentos</li>
              </ul>
            </section>

            {/* Seção 6 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                6. Seus Direitos
              </h2>
              <ul className="list-disc pl-8 space-y-2 text-gray-900">
                <li className="text-gray-900">Acessar seus dados</li>
                <li className="text-gray-900">Corrigir informações</li>
                <li className="text-gray-900">Excluir conta</li>
                <li className="text-gray-900">Portabilidade dos dados</li>
                <li className="text-gray-900">Revogar consentimento</li>
                <li className="text-gray-900">Solicitar exclusão de fotos específicas</li>
              </ul>
            </section>

            {/* Seção 7 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                7. Retenção de Dados
              </h2>
              <ul className="list-disc pl-8 space-y-2 text-gray-900">
                <li className="text-gray-900">Mantemos dados enquanto necessário</li>
                <li className="text-gray-900">Exclusão após inatividade</li>
                <li className="text-gray-900">Backup por segurança</li>
                <li className="text-gray-900">Imagens de documentos são mantidas conforme exigências legais</li>
              </ul>
            </section>

            {/* Seção 8 */}
            <section className="mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4 mt-8 border-l-4 border-green-700 pl-4">
                8. Controle de Permissões
              </h2>
              <p className="mb-4 text-gray-900">Você pode gerenciar as permissões do aplicativo através das configurações do seu dispositivo:</p>
              <ul className="list-disc pl-8 space-y-2 text-gray-900">
                <li className="text-gray-900"><strong className="text-gray-900">Android:</strong> Configurações &gt; Aplicativos &gt; Rota Entregas &gt; Permissões</li>
                <li className="text-gray-900"><strong className="text-gray-900">iOS:</strong> Configurações &gt; Privacidade e Segurança &gt; Câmera &gt; Rota Entregas</li>
              </ul>
            </section>

            {/* Seção 9 - Contato */}
            <section className="mb-8">
              <div className="bg-green-50 p-6 rounded-lg text-center border-l-4 border-green-500">
                <h2 className="text-2xl md:text-3xl font-bold text-green-700 mb-4">9. Contato</h2>
                <p className="text-gray-900 mb-4">Para dúvidas sobre privacidade:</p>
                <p className="text-gray-900 font-semibold mb-2">
                  <strong className="text-gray-900">E-mail:</strong> venekentregas@gmail.com
                </p>
                <p className="text-gray-900 font-semibold">
                  <strong className="text-gray-900">WhatsApp:</strong> (66) 99204-6909
                </p>
              </div>
            </section>

            {/* Seção 10 - Atualizações */}
            <section className="mb-8">
              <div className="bg-yellow-50 p-6 rounded-lg border-l-4 border-yellow-400">
                <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">10. Atualizações</h2>
                <p className="text-gray-900 mb-2">Esta política pode ser atualizada. Notificaremos sobre mudanças importantes.</p>
                <p className="text-gray-900 font-semibold">
                  <strong className="text-gray-900">Última atualização:</strong> Julho 2025
                </p>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="text-center mt-12 pt-8 border-t border-gray-200 text-gray-600">
            <p className="mb-2">&copy; 2026 Rota Entregas. Todos os direitos reservados.</p>
            <p>&copy; Desenvolvido por Venek Sistemas</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoliticaPrivacidade;

